<template>
    <b-form-checkbox
        class="checkbox"
        :checked="value"
        :indeterminate="indeterminate"
        :disabled="disabled"
        @change="selected"
    />
</template>

<script>
export default {

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        indeterminate: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        selected(val) {
            this.$emit('input', val);
        },
    },

};
</script>

<style lang="scss" scoped>
.checkbox {
    display: block;
    margin: 0;
    user-select: none; // prevent accidental text selection
}
</style>
